import { Http } from "@/util";

// 获取所有配置列表
export function listProblemFlowConfigs(param) {
  return Http.get("/admin/setting/problem-flow-config/list", param);
}

// 获取指定问题的配置
export function getProblemFlowConfig(problemId) {
  return Http.get("/admin/setting/problem-flow-config/get", { problemId });
}

// 保存或更新流程配置
export function saveOrUpdateProblemFlowConfig(param) {
  return Http.post("/admin/setting/problem-flow-config/save", param);
}

// 删除配置
export function deleteProblemFlowConfig(problemId) {
  return Http.get("/admin/setting/problem-flow-config/delete", { problemId });
}

// 获取所有枚举值
export function getProblemFlowConfigEnums() {
  return Http.get("/admin/setting/problem-flow-config/enums", { _useCache: true });
}
